import * as React from 'react';
import arrowImage from "../../static/assets/images/arrow-down.svg"
import ParameterLayout from "./parameterLayout";

const EnumParameter = (props) => {
    return (
        <ParameterLayout parameter={props.parameter} type={props.type} description={props.description} required={props.required} disable={props.disable}>
            <div className="value-inner--select">
                {!props.disable && <select className="d-flex select-value" style={
                    {
                        appearance: "none",
                        MozAppearance: "none",
                        WebkitAppearance: "none",
                        backgroundImage: "url(" + arrowImage + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "calc(100% - 10px) center"
                    }}
                        onChange={(e)=>props.onChange(e)}>
                    {props.values !== undefined && props.values.length > 0 &&
                        <option className="dropdown-menu dropdown-item" style={{marginBottom: "20px"}}/>}
                    {props.values !== undefined && props.values.map((value, index) => (
                        <option key={index} className="dropdown-menu dropdown-item"
                                style={{marginBottom: "20px"}}>{value}</option>
                    ))};

                </select>}
            </div>
        </ParameterLayout>
    )
}

export default EnumParameter;